var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('CustomNavBar',{attrs:{"title":"项目招商"}}),_c('bigCard',{attrs:{"data":_vm.attrList}}),_c('img',{staticClass:"bg-img1",attrs:{"src":require('@/assets/bg01.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }